<!-- <nav>
  <ul>
    <li>
      <a
        routerLink="/home"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        >First Component</a
      >
    </li>
    <li>
      <a
        routerLink="/xxxx"
        routerLinkActive="activebutton"
        ariaCurrentWhenActive="page"
        >Second Component</a
      >
    </li>
  </ul>
</nav> -->
<router-outlet></router-outlet>
